import { useEffect, useState } from 'react';
import { getCollectionCount } from '../utils/firestoreCounts';

/**
 * useBeerReviewCount
 * Fetches the number of beer reviews for a given breweryId from the beerReview collection.
 */
function useBeerReviewCount(breweryId) {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function fetchCount() {
      if (!breweryId) {
        setCount(0);
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        setError(null);
        const docCount = await getCollectionCount(
          'beerReview',
          'breweryId',
          breweryId,
        );
        if (!cancelled) {
          setCount(docCount);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message);
          setCount(0);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }
    fetchCount();
    return () => {
      cancelled = true;
    };
  }, [breweryId]);

  return { count, loading, error };
}

export default useBeerReviewCount;
